import { jsx as _jsx } from "react/jsx-runtime";
import { ObjectHistory } from '@iotv/datamodel';
import { useMemo, useState } from 'react';
import { ObjectHistoryControls } from '../../generic/ObjectHistory/ObjectHistoryControls';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectHistoryControlsWidget = () => {
    const [objectHistory, setObjectHistory] = useState(new ObjectHistory({ type: 'recentStateHistory' }));
    const component = useMemo(() => _jsx(ObjectHistoryControls, { objectHistory: objectHistory, setObjectHistory: setObjectHistory }), [objectHistory]);
    return {
        name: 'ObjectHistoryControls',
        category: 'generic',
        component,
    };
};
